import { useEffect } from "react";
import { translation as t } from "../utils/translation";
import { ROUTES } from "../constants/common";
import Header from "./header";
import CalculateMixes from "./calculateMixes";
const CalculateMixesContent = () => {

  return (
    <div id="calculateMixesContent">
      <Header
        title={t.CALCULATE_MIXES_TITLE}
        description={t.HEADER_DESCRIPTION}
        buttonTitle={t.CALCULATE_BY_PRODUCTS_BUTTON_TITLE}
        buttonText={t.CALCULATE_BY_PRODUCTS_BUTTON}
        buttonLink={ROUTES.CALCULATE_BY_PRODUCTS_CONTENT}
      />
      <h2 className="xs:p-5 xxl:p-10 text-darkBlue font-bold xs:text-[24px] xxl:text-[40px]  ">
        {t.CALCULATE_BY_PRODUCTS_TITLE}
      </h2>
      <CalculateMixes />
    </div>
  );
};
export default CalculateMixesContent;